var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivity = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325.6,511.7c-2.6,0-5.3-0.4-7.9-1.1c-9.7-2.9-17-10.2-19.8-19.7L186.2,93.6l-37.8,134.6 c-8.4,29.9-35.9,50.8-67,50.9h-58c-12.8,0-23.3-10.4-23.3-23.3c0-12.8,10.4-23.3,23.3-23.3h57.9c10.3,0,19.5-7,22.3-17l54.6-194.4 c2.9-9.8,10.3-17.2,19.8-20c15.2-4.5,31.5,4.4,36,19.7l111.6,397.2l37.8-134.6c8.4-30,36-50.9,67.2-50.9c0,0,0.1,0,0.1,0h57.6 c12.9,0,23.3,10.4,23.3,23.3c0,12.8-10.4,23.3-23.3,23.3h-57.7c0,0,0,0,0,0c-10.4,0-19.6,7-22.4,17l-54.6,194.4 C349.8,503.4,338.1,511.7,325.6,511.7z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Activity.bf9d9f46297bbae334922b5217a77456.svg";